<li class="list-item btn {{stateClass}}">
  <h4>{{item.name}}</h4>
  <h5>{{item.description}}</h5>
</li>
